import Tab from "@mui/material/Tab";
import { Outlet, useLocation, useNavigate } from "react-router";
import HomeIcon from "@mui/icons-material/Home";
import HistoryIcon from "@mui/icons-material/History";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import Stack from "@mui/material/Stack";
import useMediaQuery from "@mui/material/useMediaQuery";
import ContainedTabs from "../../components/Tabs/ContainedTabs";

export default function Gestion() {
	const location = useLocation().pathname.replace("/gestion", "").split("/");
	const navigate = useNavigate();

	const handleChange = (event, newValue) => {
		navigate(newValue);
	};

	const tabValue = location[1] ? "./" + location[1] : ".";

	const matches = useMediaQuery((t) => t.breakpoints.down("sm"));

	const routes = [
		{
			name: "Acceuil",
			link: ".",
			icon: <HomeIcon />,
		},
		{
			name: "Produits",
			link: "./produits",
			icon: <ShoppingBagIcon />,
		},
		{
			name: "Ventes",
			link: "./ventes",
			icon: <FilterFramesIcon />,
		},
		{
			name: "Historique",
			link: "./historique",
			icon: <HistoryIcon />,
		},
	];

	return (
		<Stack spacing={1}>
			<ContainedTabs
				value={tabValue}
				onChange={handleChange}
			>
				{routes.map((item) => (
					<Tab
						label={item.name}
						value={item.link}
						iconPosition={matches ? "top" : "start"}
						sx={(theme) => ({
							[theme.breakpoints.down("sm")]: {
								fontSize: 10,
								minWidth: 50,
							},
						})}
						key={item.name}
						icon={item.icon}
					/>
				))}
			</ContainedTabs>

			<Outlet />
		</Stack>
	);
}
